import colors from '../styles/Color.scss';

const themeGlobalConfig = {
  token: {
    borderRadius: 12,
    colorPrimary: colors.primaryColor,
    colorInfo: colors.primaryColor,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.danger,
    fontFamily: 'Inter,Open Sans, Tahoma, ArianAmu, Arial, sans-serif',
  },
  components: {
    Button: {
      defaultBorderColor: colors.primaryColor,
      defaultColor: colors.primaryColor,
      controlHeight: 40,
      controlHeightLG: 50,
      defaultGhostColor: colors.primaryColor,
      defaultGhostBorderColor: colors.primaryColor,
      colorPrimary: colors.primaryColor,
      colorLink: colors.primaryColor,
      controlHeightSM: 30,
      paddingInlineSM: 11,
      borderRadiusLG: colors.filterSelectBorderRadius,
      contentFontSizeLG: 14,
      borderRadiusSM: 12,
      paddingBlockLG: 4,
      paddingInlineLG: 10,
    },
    Checkbox: {
      controlInteractiveSize: 20,
      colorPrimary: colors.primaryColor,
      colorPrimaryBorder: colors.primaryColor,
    },
    Radio: {
      fontSize: 13,
    },
    Segmented: {
      fontSize: 13,
      fontSizeLG: 13,
    },
    TreeSelect: {
      titleHeight: 30,
      indentSize: 10,
    },
    Tree: {
      colorPrimary: colors.primaryColor,
    },
    Pagination: {
      fontWeightStrong: 400,
    },
    Card: {
      padding: 12,
      paddingLG: 16,
      borderRadius: 6,
      boxShadow: 'none',
    },
    Modal: {
      borderRadiusSM: 8,
      borderRadiusLG: 16,
      padding: 10,
      paddingLG: 12,
    },
    Dropdown: {
      borderRadiusLG: 6,
      padding: 10,
    },
    Tag: {
      borderRadiusSM: 20,
    },
    Layout: {
      siderBg: colors.leftMenuBg,
    },
    Menu: {
      activeBarBorderWidth: 0,
    },
    Input: {
      controlHeight: 40,
      borderRadius: 12,
      controlHeightLG: 50,
      borderRadiusLG: 9,
      fontSizeLG: 14,
    },
    InputNumber: {
      controlHeight: 40,
      borderRadius: 12,
      controlHeightLG: 50,
      borderRadiusLG: 9,
      fontSizeLG: 14,
    },
    Select: {
      controlHeight: 40,
      borderRadius: 12,
      controlHeightLG: 50,
      borderRadiusLG: 9,
      fontSizeLG: 14,
    },
    DatePicker: {
      controlHeight: 40,
      borderRadius: 12,
      controlHeightLG: 50,
      borderRadiusLG: 9,
      fontSizeLG: 14,
    },
    Table: {
      rowSelectedBg: 'rgba(230,244,255,0)',
      footerBg: 'rgba(255,255,255,0)',
    },
    Divider: {
      margin: 5,
      marginLG: 15,
    },
  },
};

export default themeGlobalConfig;
